import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { getFooterUrls } from 'constants/common';

const StyledDiv = styled('div')`
  border-bottom: 1px solid ${({ theme }) => theme.gray.medium};
  margin-bottom: 8px;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.text.dark};
  display: block;
  font-size: 13px;
  padding-bottom: 16px;
  transition: color 250ms ease-out;
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  &:not(:last-child) {
    margin-right: 32px;
  }

  &:hover {
    color: ${({ theme }) => theme.secondary.base};
  }

  @media only screen and (min-width: 500px) {
    display: inline-block;
  }
`;

function FooterLinks() {
  const { legalUrl, termsUrl, faqUrl, privacyPolicyUrl } = getFooterUrls();
  return (
    <StyledDiv>
      <StyledLink to={legalUrl} target='_blank'>
        {' '}
        Legal{' '}
      </StyledLink>
      <StyledLink to={termsUrl} target='_blank'>
        {' '}
        Terms{' '}
      </StyledLink>
      <StyledLink to={faqUrl} target='_blank'>
        {' '}
        FAQs{' '}
      </StyledLink>
      <StyledLink to={privacyPolicyUrl} target='_blank'>
        {' '}
        Privacy Policy{' '}
      </StyledLink>
    </StyledDiv>
  );
}

export default FooterLinks;
